var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 12.2502C7.75 12.6645 7.41421 13.0002 7 13.0002C6.61537 13.0002 6.29837 12.7107 6.25505 12.3377L6.25 12.2502L6.25 1.75024C6.25 1.33603 6.58579 1.00024 7 1.00024C7.38463 1.00024 7.70163 1.28977 7.74495 1.66278L7.75 1.75024L7.75 12.2502Z",
    fill: "#17B31B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7803 6.46991C13.0732 6.76281 13.0732 7.23768 12.7803 7.53057C12.51 7.80094 12.0845 7.82173 11.7903 7.59297L11.7197 7.53057L7 2.81149L2.28033 7.53057C2.00997 7.80094 1.58454 7.82173 1.29033 7.59297L1.21967 7.53057C0.949307 7.26021 0.92851 6.83479 1.15728 6.54057L1.21967 6.46991L6.46967 1.21991C6.74003 0.949551 7.16546 0.928754 7.45967 1.15752L7.53033 1.21991L12.7803 6.46991Z",
    fill: "#17B31B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessUpArrow);
export default __webpack_public_path__ + "static/media/success-up-arrow.8b96713cca26defbf1f90ee0492653e7.svg";
export { ForwardRef as ReactComponent };